// shop-the-look.js

document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.shop-the-look');

    sections.forEach((section) => {
        const hotspots = Array.from(section.querySelectorAll('.shop-the-look__hotspot'));

        hotspots.forEach((hotspot) => {
            hotspot.setAttribute('aria-hidden', 'true');
        });
    });
});
